import { Axios } from "../../Services/Axios";

export const fetchHeardAboutUs = async () => {
  return await Axios.get("/store/customers/heard-about-us", {
    responseType: "json",
  });
};

export const fetchCustomers = async (url = undefined, params = undefined) => {
  return await Axios.get(url || `/store/customers/list${params || ""}`, {
    responseType: "json",
  });
};
export const fetchCustomerDetails = async (id) => {
  return await Axios.get(`/store/customers/${id}`, {
    responseType: "json",
  });
};
export const customerRegister = async (payload) => {
  return await Axios.post("/store/customers/register", payload, {
    responseType: "json",
  });
};
